import React from 'react';
import './Footer.css';
import { trackEvent } from '../utils/ga.js';

const Footer = ({ provider, setProvider }) => {
    const handleProviderChange = (newProvider) => {
        if (provider !== newProvider) {
            setProvider(newProvider);
            trackEvent('change_provider', { to_provider: newProvider });
        }
    };

    return (
        <footer className="app-footer">
            <div className="footer-info">
                <p className="version-info">KoVnTalk Ai Translater Ver.250710</p>
                <p>Contact: koVnTalk@gmail.com</p>
                <p>@copyright Minseo Jeong</p>
            </div>
            <div className="provider-selector">
                <button className={provider === 'AI A' ? 'active' : ''}
                        onClick={() => handleProviderChange('AI A')}>AI A
                </button>
                <button className={provider === 'AI B' ? 'active' : ''}
                        onClick={() => handleProviderChange('AI B')}>AI B
                </button>
            </div>
        </footer>
    );
};

export default Footer;